import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";
import { Check, X } from "@phosphor-icons/react";

export default function Approvals() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/leave/approvals");
      setItems(data);
    } catch (e) { toast.error(formatApiError(e)); }
  };

  useEffect(() => { load(); }, []);

  const decide = async (id, decision) => {
    try {
      await api.post(`/leave/requests/${id}/decide`, { decision });
      toast.success(decision === "APPROVE" ? "Approved" : "Rejected");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-black/60">{t("approvals")}</div>
      <h1 className="font-display font-black text-5xl tracking-tighter leading-none mb-6">Approval queue</h1>

      <div className="grid gap-4">
        {items.map((i) => (
          <div key={i.id} className="brut-border bg-white p-4 brut-shadow flex items-center justify-between gap-4" data-testid={`approval-row-${i.id}`}>
            <div className="flex-1">
              <div className="flex items-center gap-3">
                <div className="font-display font-black text-xl tracking-tighter">{i.user?.name || i.user_id}</div>
                <span className="tag bg-[#FFCC00]">{i.type}</span>
                <span className="tag bg-white">{i.days} {t("days").toLowerCase()}</span>
              </div>
              <div className="text-xs font-mono text-black/60 mt-1">
                {new Date(i.start_date).toLocaleDateString()} → {new Date(i.end_date).toLocaleDateString()}
              </div>
              {i.reason && <div className="text-sm mt-2">{i.reason}</div>}
            </div>
            <div className="flex gap-2">
              <button
                data-testid={`approve-${i.id}`}
                onClick={() => decide(i.id, "APPROVE")}
                className="bg-[#00CC33] text-black brut-border brut-shadow brut-hover px-4 py-2 font-bold uppercase tracking-wider text-xs flex items-center gap-1"
              >
                <Check size={16} weight="bold" /> {t("approve")}
              </button>
              <button
                data-testid={`reject-${i.id}`}
                onClick={() => decide(i.id, "REJECT")}
                className="bg-[#FF3333] text-white brut-border brut-shadow brut-hover px-4 py-2 font-bold uppercase tracking-wider text-xs flex items-center gap-1"
              >
                <X size={16} weight="bold" /> {t("reject")}
              </button>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="brut-border bg-white p-8 text-center text-black/60">{t("no_data")}</div>
        )}
      </div>
    </div>
  );
}
